var map = {
	"./asus_pacc_sw_ico_appointment.svg": "./src/assets/svg/asus_pacc_sw_ico_appointment.svg",
	"./asus_pacc_sw_ico_drawer_sidebar.svg": "./src/assets/svg/asus_pacc_sw_ico_drawer_sidebar.svg",
	"./asus_pacc_sw_ico_history.svg": "./src/assets/svg/asus_pacc_sw_ico_history.svg",
	"./asus_pacc_sw_ico_reset.svg": "./src/assets/svg/asus_pacc_sw_ico_reset.svg",
	"./asus_pacc_sw_ico_table_visible.svg": "./src/assets/svg/asus_pacc_sw_ico_table_visible.svg",
	"./asus_proart_sw_ico_arrow_fill_collapse.svg": "./src/assets/svg/asus_proart_sw_ico_arrow_fill_collapse.svg",
	"./asus_proart_sw_ico_arrow_fill_expand.svg": "./src/assets/svg/asus_proart_sw_ico_arrow_fill_expand.svg",
	"./asus_proart_sw_ico_arrow_s3.svg": "./src/assets/svg/asus_proart_sw_ico_arrow_s3.svg",
	"./asus_proart_sw_ico_cancel.svg": "./src/assets/svg/asus_proart_sw_ico_cancel.svg",
	"./asus_proart_sw_ico_color.svg": "./src/assets/svg/asus_proart_sw_ico_color.svg",
	"./asus_proart_sw_ico_control_settings.svg": "./src/assets/svg/asus_proart_sw_ico_control_settings.svg",
	"./asus_proart_sw_ico_delete.svg": "./src/assets/svg/asus_proart_sw_ico_delete.svg",
	"./asus_proart_sw_ico_download.svg": "./src/assets/svg/asus_proart_sw_ico_download.svg",
	"./asus_proart_sw_ico_edit_1.svg": "./src/assets/svg/asus_proart_sw_ico_edit_1.svg",
	"./asus_proart_sw_ico_file_text.svg": "./src/assets/svg/asus_proart_sw_ico_file_text.svg",
	"./asus_proart_sw_ico_last.svg": "./src/assets/svg/asus_proart_sw_ico_last.svg",
	"./asus_proart_sw_ico_lock.svg": "./src/assets/svg/asus_proart_sw_ico_lock.svg",
	"./asus_proart_sw_ico_next-more.svg": "./src/assets/svg/asus_proart_sw_ico_next-more.svg",
	"./asus_proart_sw_ico_notification.svg": "./src/assets/svg/asus_proart_sw_ico_notification.svg",
	"./asus_proart_sw_ico_settings.svg": "./src/assets/svg/asus_proart_sw_ico_settings.svg",
	"./asus_proart_sw_ico_task.svg": "./src/assets/svg/asus_proart_sw_ico_task.svg",
	"./asus_proart_sw_ico_unlock.svg": "./src/assets/svg/asus_proart_sw_ico_unlock.svg",
	"./check.svg": "./src/assets/svg/check.svg",
	"./collapse.svg": "./src/assets/svg/collapse.svg",
	"./delete.svg": "./src/assets/svg/delete.svg",
	"./download.svg": "./src/assets/svg/download.svg",
	"./dropdown.svg": "./src/assets/svg/dropdown.svg",
	"./icon-add.svg": "./src/assets/svg/icon-add.svg",
	"./icon-back.svg": "./src/assets/svg/icon-back.svg",
	"./icon-check.svg": "./src/assets/svg/icon-check.svg",
	"./icon-paste.svg": "./src/assets/svg/icon-paste.svg",
	"./icon-refresh.svg": "./src/assets/svg/icon-refresh.svg",
	"./icon-search.svg": "./src/assets/svg/icon-search.svg",
	"./imaker-ico-expand.svg": "./src/assets/svg/imaker-ico-expand.svg",
	"./search.svg": "./src/assets/svg/search.svg",
	"./top-accounts_portrait_n.svg": "./src/assets/svg/top-accounts_portrait_n.svg",
	"./top-email_n.svg": "./src/assets/svg/top-email_n.svg",
	"./top-info_n.svg": "./src/assets/svg/top-info_n.svg",
	"./top-language.svg": "./src/assets/svg/top-language.svg",
	"./ui-menu-calibration.svg": "./src/assets/svg/ui-menu-calibration.svg",
	"./ui-menu-cloud.svg": "./src/assets/svg/ui-menu-cloud.svg",
	"./ui-menu-dashboard.svg": "./src/assets/svg/ui-menu-dashboard.svg",
	"./ui-menu-device.svg": "./src/assets/svg/ui-menu-device.svg",
	"./ui-menu-group.svg": "./src/assets/svg/ui-menu-group.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg sync \\.svg$";